module.exports = __webpack_public_path__ + "img/39_20.be537eb0.png";